import * as React from 'react';
import { resolve } from 'inversify-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { MarketListDataService } from 'src/app/general/market/list/market-list.data';
import { MarketEditorCheckListView } from './market-editor-checkList.view';

interface MarketEditorCheckListControllerProps {
	value: number | null;
	mode: ControlMode;
	onChanged: (value: number | null) => void;
	setBusy(isBusy: boolean);
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class MarketEditorCheckListController extends React.Component<MarketEditorCheckListControllerProps, {}> {
	private marketDataService: MarketListDataService;

	@resolve
	private toast: ToastNotifications;

	public componentDidMount() {
		this.load();
	}

	public render() {
		if (this.marketDataService == null) {
			return null;
		}
		return (
			<MarketEditorCheckListView
				markets={this.marketDataService.items}
				onGetErrorMessage={this.props.onGetErrorMessage}
				{...this.props}
			/>
		);
	}

	private load() {
		try {
			this.props.setBusy(true);
			this.marketDataService = MarketListDataService.make();
			this.marketDataService.addFilter('isDeleted', 'eq', false);
			this.marketDataService.addSorting('id', 'asc', true);
			this.marketDataService.load(query => query);
		} catch (error) {
			this.toast.showToast("Error in request!", ObjectUtils.parseError(error), "error");
		} finally {
			this.props.setBusy(false);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/general/market/parts/market-editor-checkList.controller.tsx